// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ERDModal.module.css */

.ERDModal_modalOverlay__Zprsh {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    padding: 20px;
}

.ERDModal_modalOverlay__Zprsh.ERDModal_fullscreen__yyw0m {
    padding: 0;
}

.ERDModal_modalContent__IpqGT {
    background: white;
    border-radius: 8px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
    max-width: calc(90vw / var(--app-zoom, 1));
    max-height: calc(90vh / var(--app-zoom, 1));
    width: 1200px;
    height: calc(80vh / var(--app-zoom, 1));
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.ERDModal_modalContent__IpqGT.ERDModal_fullscreenContent__40yoF {
    max-width: calc(100vw / var(--app-zoom, 1));
    max-height: calc(100vh / var(--app-zoom, 1));
    width: calc(100vw / var(--app-zoom, 1));
    height: calc(100vh / var(--app-zoom, 1));
    border-radius: 0;
}

.ERDModal_modalHeader__iajJQ {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px 16px 24px;
    border-bottom: 1px solid #e1e5e9;
    background-color: #f8f9fa;
    gap: 16px;
}

.ERDModal_modalTitle__7AfPi {
    margin: 0;
    font-size: 1.5rem;
    font-weight: 600;
    color: #2c3e50;
}

.ERDModal_zoomControls__xxlhs {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1 1;
    justify-content: center;
}

.ERDModal_zoomSelect__mRQVl {
    padding: 4px 8px;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    background-color: white;
    font-size: 0.9rem;
    min-width: 100px;
}

.ERDModal_zoomSelect__mRQVl:focus {
    outline: none;
    border-color: #333333;
    box-shadow: 0 0 0 2px rgba(51, 51, 51, 0.25);
}

.ERDModal_modalControls__yku4P {
    display: flex;
    align-items: center;
    gap: 8px;
}

.ERDModal_controlButton__iX91c {
    background: none;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    padding: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    color: #6c757d;
}

.ERDModal_controlButton__iX91c:hover {
    background-color: #e9ecef;
    border-color: #adb5bd;
    color: #495057;
}

.ERDModal_closeButton__6WnVw {
    background: none;
    border: 1px solid #dc3545;
    border-radius: 4px;
    padding: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    color: #dc3545;
}

.ERDModal_closeButton__6WnVw:hover {
    background-color: #dc3545;
    color: white;
}

.ERDModal_modalBody__A7IIo {
    flex: 1 1;
    padding: 20px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.ERDModal_loadingContainer__cucSt {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #6c757d;
}

.ERDModal_spinner__rvl2n {
    width: 40px;
    height: 40px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #333333;
    border-radius: 50%;
    animation: ERDModal_spin__6giqz 1s linear infinite;
    margin-bottom: 16px;
}

@keyframes ERDModal_spin__6giqz {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.ERDModal_errorContainer__wdV0A {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.ERDModal_errorMessage__rVlXz {
    color: #dc3545;
    font-size: 1.1rem;
    margin-bottom: 16px;
    text-align: center;
}

.ERDModal_retryButton__58lRF {
    background-color: #333333;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 1rem;
    transition: background-color 0.2s ease;
}

.ERDModal_retryButton__58lRF:hover {
    background-color: #000000;
}

.ERDModal_diagramContainer__qy3p8 {
    flex: 1 1;
    overflow: auto;
    background-color: #fafafa;
    border: 1px solid #e1e5e9;
    border-radius: 4px;
    padding: 20px;
    position: relative;
    cursor: grab;
    -webkit-user-select: none;
            user-select: none;
}

.ERDModal_diagramWrapper__b9os8 {
    width: max-content;
    height: max-content;
    min-width: 100%;
    min-height: 400px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
}

.ERDModal_diagramWrapper__b9os8 svg {
    display: block;
}

.ERDModal_emptyContainer__X4sAy {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #6c757d;
    font-size: 1.1rem;
}

/* 스크롤바 스타일링 */
.ERDModal_diagramContainer__qy3p8::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}

.ERDModal_diagramContainer__qy3p8::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}

.ERDModal_diagramContainer__qy3p8::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
}

.ERDModal_diagramContainer__qy3p8::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

/* 새로운 레이아웃 스타일 */
.ERDModal_bodyLayout__uJ-Nl {
    display: flex;
    height: 100%;
    gap: 1px;
}

.ERDModal_tableListPanel__PHBru {
    width: 280px;
    background-color: #f8f9fa;
    border-right: 1px solid #e1e5e9;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.ERDModal_tableListHeader__CdiJs {
    padding: 12px;
    border-bottom: 1px solid #e1e5e9;
    background-color: white;
}

.ERDModal_tableListHeader__CdiJs h3 {
    margin: 0 0 8px 0;
    font-size: 1rem;
    font-weight: 600;
    color: #2c3e50;
}

.ERDModal_schemaSelectContainer__1WEhp {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 8px;
}

.ERDModal_schemaLabel__kR4Eb {
    font-size: 0.9rem;
    color: #495057;
    font-weight: 500;
    white-space: nowrap;
}

.ERDModal_schemaSelect__OmZHy {
    width: 120px;
    padding: 4px 8px;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    font-size: 0.85rem;
    background-color: white;
    cursor: pointer;
}

.ERDModal_schemaSelect__OmZHy:focus {
    outline: none;
    border-color: #333333;
    box-shadow: 0 0 0 2px rgba(51, 51, 51, 0.25);
}

.ERDModal_searchInput__D9bpY {
    width: 200px;
    padding: 4px 8px;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    font-size: 0.85rem;
    margin-bottom: 8px;
}

.ERDModal_searchInput__D9bpY:focus {
    outline: none;
    border-color: #333333;
    box-shadow: 0 0 0 2px rgba(51, 51, 51, 0.25);
}

.ERDModal_selectAllContainer__1tJzc {
    margin-top: 8px;
}

.ERDModal_checkboxLabel__9mQfH {
    display: flex;
    align-items: center;
    font-size: 0.9rem;
    color: #495057;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
}

.ERDModal_checkbox__ELBvp {
    margin-right: 8px;
    cursor: pointer;
}

.ERDModal_tableList__dE63b {
    flex: 1 1;
    overflow-y: auto;
    padding: 8px;
}

.ERDModal_tableItem__OFuHT {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    margin: 2px 0;
    background-color: white;
    border: 1px solid #e9ecef;
    border-radius: 4px;
    transition: all 0.2s ease;
    font-size: 0.85rem;
    gap: 8px;
}

.ERDModal_tableItem__OFuHT:hover {
    border-color: #333333;
}

.ERDModal_tableItem__OFuHT input[type="checkbox"]:checked ~ .ERDModal_tableName__Apx71 {
    font-weight: 600;
    color: #333333;
}

/* 드래그 앤 드롭 스타일 */
.ERDModal_tableItem__OFuHT[draggable="true"] {
    cursor: move;
    transition: all 0.2s ease;
}

.ERDModal_tableItem__OFuHT[draggable="true"]:hover {
    background-color: #f5f5f5;
    box-shadow: 0 2px 8px rgba(51, 51, 51, 0.2);
}

.ERDModal_tableItem__OFuHT.ERDModal_dragging__NHtzh {
    opacity: 0.6;
    background-color: #e8e8e8 !important;
    border: 2px dashed #333333 !important;
    z-index: 1000;
}

.ERDModal_tableItem__OFuHT.ERDModal_dragOver__lBV-B {
    border-top: 3px solid #333333 !important;
    background-color: #f5f5f5 !important;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(51, 51, 51, 0.3);
}

.ERDModal_tableName__Apx71 {
    word-break: break-all;
    line-height: 1.3;
    cursor: pointer;
    flex: 1 1;
    padding: 2px 4px;
    border-radius: 3px;
    transition: background-color 0.2s ease;
}

.ERDModal_tableName__Apx71:hover {
    background-color: #e8e8e8;
    color: #333333;
}

.ERDModal_diagramArea__ea7A\\+ {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

/* 테이블 목록 스크롤바 스타일링 */
.ERDModal_tableList__dE63b::-webkit-scrollbar {
    width: 6px;
}

.ERDModal_tableList__dE63b::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
}

.ERDModal_tableList__dE63b::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
}

.ERDModal_tableList__dE63b::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

/* 소스 코드 컨테이너 스타일 */
.ERDModal_sourceCodeContainer__ZW6Kc {
    flex: 1 1;
    overflow: hidden;
    background-color: #fafafa;
    border: 1px solid #e1e5e9;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
}

.ERDModal_sourceCodeHeader__8eQi5 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    border-bottom: 1px solid #e1e5e9;
    background-color: #f8f9fa;
}

.ERDModal_sourceCodeHeader__8eQi5 h3 {
    margin: 0;
    font-size: 1.1rem;
    font-weight: 600;
    color: #2c3e50;
}

.ERDModal_copyButton__Gq8pb {
    background-color: #333333;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 0.9rem;
    transition: background-color 0.2s ease;
}

.ERDModal_copyButton__Gq8pb:hover {
    background-color: #000000;
}

.ERDModal_sourceCode__SHbSC {
    flex: 1 1;
    overflow: auto;
    margin: 0;
    padding: 20px;
    background-color: #f8f9fa;
    font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
    font-size: 0.9rem;
    line-height: 1.5;
    white-space: pre-wrap;
    word-wrap: break-word;
}

.ERDModal_sourceCode__SHbSC code {
    background: none;
    padding: 0;
    border: none;
    color: #2c3e50;
}

/* 소스 코드 스크롤바 스타일링 */
.ERDModal_sourceCode__SHbSC::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}

.ERDModal_sourceCode__SHbSC::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}

.ERDModal_sourceCode__SHbSC::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
}

.ERDModal_sourceCode__SHbSC::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

/* 비활성화된 버튼 스타일 */
.ERDModal_controlButton__iX91c:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/* 반응형 디자인 */
@media (max-width: 768px) {
    .ERDModal_modalOverlay__Zprsh {
        padding: 10px;
    }

    .ERDModal_modalContent__IpqGT {
        width: 100%;
        height: calc(95vh / var(--app-zoom, 1));
        max-width: 100%;
        max-height: calc(95vh / var(--app-zoom, 1));
    }

    .ERDModal_modalHeader__iajJQ {
        padding: 16px;
    }

    .ERDModal_modalTitle__7AfPi {
        font-size: 1.3rem;
    }

    .ERDModal_modalBody__A7IIo {
        padding: 16px;
    }

    .ERDModal_bodyLayout__uJ-Nl {
        flex-direction: column;
    }

    .ERDModal_tableListPanel__PHBru {
        width: 100%;
        height: 200px;
        border-right: none;
        border-bottom: 1px solid #e1e5e9;
    }

    .ERDModal_diagramArea__ea7A\\+ {
        flex: 1 1;
        min-height: 300px;
    }
}

/* Mermaid ERD 스타일 커스터마이징 */
.ERDModal_diagramWrapper__b9os8 .er {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.ERDModal_diagramWrapper__b9os8 .er .entityBox {
    fill: #f8f9fa;
    stroke: #6c757d;
    stroke-width: 1px;
}

.ERDModal_diagramWrapper__b9os8 .er .entityLabel {
    fill: #2c3e50;
    font-weight: 900;
    font-size: 18px;
}

.ERDModal_diagramWrapper__b9os8 .er .attributeBoxEven {
    fill: #ffffff;
    stroke: #dee2e6;
}

.ERDModal_diagramWrapper__b9os8 .er .attributeBoxOdd {
    fill: #f8f9fa;
    stroke: #dee2e6;
}

/* ======== 다크모드 ======== */
[data-theme="dark"] .ERDModal_modalContent__IpqGT { background: var(--color-bg); }
[data-theme="dark"] .ERDModal_modalHeader__iajJQ { background: var(--color-bg-secondary); border-color: var(--color-border); }
[data-theme="dark"] .ERDModal_modalTitle__7AfPi { color: var(--color-text); }
[data-theme="dark"] .ERDModal_zoomSelect__mRQVl { background: var(--color-bg); color: var(--color-text); border-color: var(--color-border); }
[data-theme="dark"] .ERDModal_controlButton__iX91c { background: transparent; border-color: var(--color-border); color: var(--color-text-muted); }
[data-theme="dark"] .ERDModal_controlButton__iX91c:hover { background: var(--color-hover); color: var(--color-text); }

[data-theme="dark"] .ERDModal_diagramContainer__qy3p8 { background: var(--color-bg); border-color: var(--color-border); }
[data-theme="dark"] .ERDModal_emptyContainer__X4sAy, [data-theme="dark"] .ERDModal_loadingContainer__cucSt, [data-theme="dark"] .ERDModal_checkboxLabel__9mQfH, [data-theme="dark"] .ERDModal_schemaLabel__kR4Eb { color: var(--color-text); }

[data-theme="dark"] .ERDModal_tableListPanel__PHBru { background: var(--color-bg); border-color: var(--color-border); }
[data-theme="dark"] .ERDModal_tableListHeader__CdiJs { background: var(--color-bg-secondary); border-color: var(--color-border); }
[data-theme="dark"] .ERDModal_tableListHeader__CdiJs h3 { color: var(--color-text); }

[data-theme="dark"] .ERDModal_schemaSelect__OmZHy, [data-theme="dark"] .ERDModal_searchInput__D9bpY { background: var(--color-bg); color: var(--color-text); border-color: var(--color-border); }
[data-theme="dark"] .ERDModal_schemaSelect__OmZHy:focus, [data-theme="dark"] .ERDModal_searchInput__D9bpY:focus { border-color: var(--color-primary); box-shadow: 0 0 0 2px rgba(33,150,243,0.3); }

[data-theme="dark"] .ERDModal_tableItem__OFuHT { background: var(--color-bg-secondary); border-color: var(--color-border); color: var(--color-text); }
[data-theme="dark"] .ERDModal_tableItem__OFuHT:hover { border-color: var(--color-text); background: var(--color-hover); }
[data-theme="dark"] .ERDModal_tableItem__OFuHT input[type="checkbox"]:checked ~ .ERDModal_tableName__Apx71 { color: var(--color-text); }
[data-theme="dark"] .ERDModal_tableName__Apx71:hover { background: var(--color-hover); color: var(--color-text); }

[data-theme="dark"] .ERDModal_sourceCodeContainer__ZW6Kc { border-color: var(--color-border); }
[data-theme="dark"] .ERDModal_sourceCodeHeader__8eQi5 { background: var(--color-bg-secondary); border-color: var(--color-border); }
[data-theme="dark"] .ERDModal_sourceCodeHeader__8eQi5 h3 { color: var(--color-text); }
[data-theme="dark"] .ERDModal_sourceCode__SHbSC { background: var(--color-bg); color: var(--color-text); }

/* 다크모드 ERD - CSS 모듈에서는 ERD가 global 렌더링되므로 특수 처리 */
[data-theme="dark"] .ERDModal_diagramWrapper__b9os8 .er .entityBox { fill: var(--color-bg-secondary); stroke: var(--color-border); }
[data-theme="dark"] .ERDModal_diagramWrapper__b9os8 .er .entityLabel { fill: var(--color-text); }
[data-theme="dark"] .ERDModal_diagramWrapper__b9os8 .er .attributeBoxEven { fill: var(--color-bg); stroke: var(--color-border); }
[data-theme="dark"] .ERDModal_diagramWrapper__b9os8 .er .attributeBoxOdd { fill: var(--color-bg-tertiary); stroke: var(--color-border); }
[data-theme="dark"] .ERDModal_diagramWrapper__b9os8 .er text { fill: var(--color-text) !important; }
[data-theme="dark"] .ERDModal_diagramWrapper__b9os8 .er rect { stroke: var(--color-border); }
[data-theme="dark"] .ERDModal_diagramWrapper__b9os8 .er path { stroke: #888 !important; } /* 관계선 대비 */
/*
 * 주변만 보기 — 큰 스키마에서 ERD 를 되살리는 축은 **표를 줄이는 것**이다.
 * (컬럼을 숨기면 표 300개는 여전히 300개고 정보만 빠진다)
 */
.ERDModal_hopContainer__gKCry { margin-top: 10px; }
.ERDModal_hopRow__mA\\+zZ { display: flex; gap: 4px; margin-top: 4px; }
.ERDModal_hopSelect__Dxnd1 { flex: 1 1; min-width: 0; }
.ERDModal_hopSelect__Dxnd1, .ERDModal_hopDepth__Ec-Hn, .ERDModal_hopApply__pnPBq {
  padding: 4px 6px; font-size: 12px; border-radius: 4px;
  border: 1px solid var(--color-border, #ccc);
  background: var(--color-bg, #fff); color: var(--color-text, #222);
}
.ERDModal_hopApply__pnPBq { cursor: pointer; white-space: nowrap; }
.ERDModal_hopApply__pnPBq:disabled { opacity: 0.5; cursor: default; }
.ERDModal_hopHint__zVXcB { margin-top: 4px; font-size: 10.5px; line-height: 1.5; opacity: 0.6; }

[data-theme="dark"] .ERDModal_hopSelect__Dxnd1,
[data-theme="dark"] .ERDModal_hopDepth__Ec-Hn,
[data-theme="dark"] .ERDModal_hopApply__pnPBq {
  background: var(--color-bg-tertiary, #2a2a2a);
  border-color: var(--color-border, #444);
  color: var(--color-text, #eee);
}

/*
 * 관계선 — mermaid 기본 선이 **너무 옅어 안 보인다**(특히 다크에서, 그리고 추정 관계의
 * 점선은 더 흐리다). 선이 안 보이면 ERD 는 상자 목록일 뿐이다.
 *
 * 색은 상자 테두리보다 진하게, 굵기는 1.6px. 점선은 간격을 넓혀 실선과 **한눈에** 갈린다 —
 * 선언된 FK 와 추정을 구분하는 것이 이 화면의 요점이다.
 */
.ERDModal_diagramContainer__qy3p8 svg .relationshipLine,
.ERDModal_diagramContainer__qy3p8 svg path.relationshipLine,
.ERDModal_diagramContainer__qy3p8 svg .er.relationshipLine {
  stroke: #4a6f96 !important;
  stroke-width: 1.6px !important;
}
/* mermaid 는 점선을 **클래스**(\`edge-pattern-dashed\`)로 건다 — 속성 선택자로는 안 잡힌다 */
.ERDModal_diagramContainer__qy3p8 svg .relationshipLine.edge-pattern-dashed {
  stroke: #9a6b17 !important;      /* 추정 — 노란 계열로 확정과 구분 */
  stroke-dasharray: 7 5 !important;
}
/* 관계 라벨도 옅어서 어느 컬럼으로 이어지는지 안 읽힌다 */
/* 라벨 뒤 상자 — 기본이 반투명이라 선과 겹치면 글자가 안 읽힌다 */
.ERDModal_diagramContainer__qy3p8 svg .relationshipLabelBox { opacity: 0.92; }

[data-theme="dark"] .ERDModal_diagramContainer__qy3p8 svg .relationshipLine,
[data-theme="dark"] .ERDModal_diagramContainer__qy3p8 svg path.relationshipLine,
[data-theme="dark"] .ERDModal_diagramContainer__qy3p8 svg .er.relationshipLine {
  stroke: #8ab4e8 !important;
}
[data-theme="dark"] .ERDModal_diagramContainer__qy3p8 svg .relationshipLine.edge-pattern-dashed {
  stroke: #e0be82 !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/ERDModal.module.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAExB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,0CAA0C;IAC1C,0CAA0C;IAC1C,2CAA2C;IAC3C,aAAa;IACb,uCAAuC;IACvC,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,2CAA2C;IAC3C,4CAA4C;IAC5C,uCAAuC;IACvC,wCAAwC;IACxC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,4BAA4B;IAC5B,gCAAgC;IAChC,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,SAAO;IACP,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,kDAAkC;IAClC,mBAAmB;AACvB;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,SAAO;IACP,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,iBAAiB;AACrB;;AAEA,cAAc;AACd;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,YAAY;IACZ,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,+BAA+B;IAC/B,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA,iBAAiB;AACjB;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,2CAA2C;AAC/C;;AAEA;IACI,YAAY;IACZ,oCAAoC;IACpC,qCAAqC;IACrC,aAAa;AACjB;;AAEA;IACI,wCAAwC;IACxC,oCAAoC;IACpC,2BAA2B;IAC3B,4CAA4C;AAChD;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,SAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA,qBAAqB;AACrB;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,mBAAmB;AACnB;IACI,SAAO;IACP,gBAAgB;IAChB,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;IAChC,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,SAAO;IACP,cAAc;IACd,SAAS;IACT,aAAa;IACb,yBAAyB;IACzB,2DAA2D;IAC3D,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,cAAc;AAClB;;AAEA,oBAAoB;AACpB;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,iBAAiB;AACjB;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,YAAY;AACZ;IACI;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,uCAAuC;QACvC,eAAe;QACf,2CAA2C;IAC/C;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,aAAa;QACb,kBAAkB;QAClB,gCAAgC;IACpC;;IAEA;QACI,SAAO;QACP,iBAAiB;IACrB;AACJ;;AAEA,2BAA2B;AAC3B;IACI,4DAA4D;AAChE;;AAEA;IACI,aAAa;IACb,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA,2BAA2B;AAC3B,oDAA6C,2BAA2B,EAAE;AAC1E,mDAA4C,qCAAqC,EAAE,iCAAiC,EAAE;AACtH,kDAA2C,wBAAwB,EAAE;AACrE,kDAA2C,2BAA2B,EAAE,wBAAwB,EAAE,iCAAiC,EAAE;AACrI,qDAA8C,uBAAuB,EAAE,iCAAiC,EAAE,8BAA8B,EAAE;AAC1I,2DAAoD,8BAA8B,EAAE,wBAAwB,EAAE;;AAE9G,wDAAiD,2BAA2B,EAAE,iCAAiC,EAAE;AACjH,mNAAuL,wBAAwB,EAAE;;AAEjN,sDAA+C,2BAA2B,EAAE,iCAAiC,EAAE;AAC/G,uDAAgD,qCAAqC,EAAE,iCAAiC,EAAE;AAC1H,0DAAmD,wBAAwB,EAAE;;AAE7E,sGAAwF,2BAA2B,EAAE,wBAAwB,EAAE,iCAAiC,EAAE;AAClL,kHAAoG,kCAAkC,EAAE,0CAA0C,EAAE;;AAEpL,iDAA0C,qCAAqC,EAAE,iCAAiC,EAAE,wBAAwB,EAAE;AAC9I,uDAAgD,+BAA+B,EAAE,8BAA8B,EAAE;AACjH,6GAAsF,wBAAwB,EAAE;AAChH,uDAAgD,8BAA8B,EAAE,wBAAwB,EAAE;;AAE1G,2DAAoD,iCAAiC,EAAE;AACvF,wDAAiD,qCAAqC,EAAE,iCAAiC,EAAE;AAC3H,2DAAoD,wBAAwB,EAAE;AAC9E,kDAA2C,2BAA2B,EAAE,wBAAwB,EAAE;;AAElG,kDAAkD;AAClD,qEAAuE,+BAA+B,EAAE,2BAA2B,EAAE;AACrI,uEAAyE,uBAAuB,EAAE;AAClG,4EAA8E,qBAAqB,EAAE,2BAA2B,EAAE;AAClI,2EAA6E,8BAA8B,EAAE,2BAA2B,EAAE;AAC1I,+DAAiE,kCAAkC,EAAE;AACrG,+DAAiE,2BAA2B,EAAE;AAC9F,+DAAiE,uBAAuB,EAAE,EAAE,WAAW;AACvG;;;EAGE;AACF,gCAAgB,gBAAgB,EAAE;AAClC,2BAAU,aAAa,EAAE,QAAQ,EAAE,eAAe,EAAE;AACpD,6BAAa,SAAO,EAAE,YAAY,EAAE;AACpC;EACE,gBAAgB,EAAE,eAAe,EAAE,kBAAkB;EACrD,2CAA2C;EAC3C,iCAAiC,EAAE,8BAA8B;AACnE;AACA,4BAAY,eAAe,EAAE,mBAAmB,EAAE;AAClD,qCAAqB,YAAY,EAAE,eAAe,EAAE;AACpD,2BAAW,eAAe,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,YAAY,EAAE;;AAE/E;;;EAGE,6CAA6C;EAC7C,uCAAuC;EACvC,8BAA8B;AAChC;;AAEA;;;;;;EAME;AACF;;;EAGE,0BAA0B;EAC1B,8BAA8B;AAChC;AACA,sEAAsE;AACtE;EACE,0BAA0B,OAAO,uBAAuB;EACxD,gCAAgC;AAClC;AACA,mCAAmC;AACnC,yCAAyC;AACzC,8DAAuD,aAAa,EAAE;;AAEtE;;;EAGE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B","sourcesContent":["/* ERDModal.module.css */\r\n\r\n.modalOverlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: rgba(0, 0, 0, 0.6);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    z-index: 9999;\r\n    padding: 20px;\r\n}\r\n\r\n.modalOverlay.fullscreen {\r\n    padding: 0;\r\n}\r\n\r\n.modalContent {\r\n    background: white;\r\n    border-radius: 8px;\r\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);\r\n    max-width: calc(90vw / var(--app-zoom, 1));\r\n    max-height: calc(90vh / var(--app-zoom, 1));\r\n    width: 1200px;\r\n    height: calc(80vh / var(--app-zoom, 1));\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow: hidden;\r\n}\r\n\r\n.modalContent.fullscreenContent {\r\n    max-width: calc(100vw / var(--app-zoom, 1));\r\n    max-height: calc(100vh / var(--app-zoom, 1));\r\n    width: calc(100vw / var(--app-zoom, 1));\r\n    height: calc(100vh / var(--app-zoom, 1));\r\n    border-radius: 0;\r\n}\r\n\r\n.modalHeader {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 20px 24px 16px 24px;\r\n    border-bottom: 1px solid #e1e5e9;\r\n    background-color: #f8f9fa;\r\n    gap: 16px;\r\n}\r\n\r\n.modalTitle {\r\n    margin: 0;\r\n    font-size: 1.5rem;\r\n    font-weight: 600;\r\n    color: #2c3e50;\r\n}\r\n\r\n.zoomControls {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    flex: 1;\r\n    justify-content: center;\r\n}\r\n\r\n.zoomSelect {\r\n    padding: 4px 8px;\r\n    border: 1px solid #dee2e6;\r\n    border-radius: 4px;\r\n    background-color: white;\r\n    font-size: 0.9rem;\r\n    min-width: 100px;\r\n}\r\n\r\n.zoomSelect:focus {\r\n    outline: none;\r\n    border-color: #333333;\r\n    box-shadow: 0 0 0 2px rgba(51, 51, 51, 0.25);\r\n}\r\n\r\n.modalControls {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n}\r\n\r\n.controlButton {\r\n    background: none;\r\n    border: 1px solid #dee2e6;\r\n    border-radius: 4px;\r\n    padding: 8px;\r\n    cursor: pointer;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    transition: all 0.2s ease;\r\n    color: #6c757d;\r\n}\r\n\r\n.controlButton:hover {\r\n    background-color: #e9ecef;\r\n    border-color: #adb5bd;\r\n    color: #495057;\r\n}\r\n\r\n.closeButton {\r\n    background: none;\r\n    border: 1px solid #dc3545;\r\n    border-radius: 4px;\r\n    padding: 8px;\r\n    cursor: pointer;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    transition: all 0.2s ease;\r\n    color: #dc3545;\r\n}\r\n\r\n.closeButton:hover {\r\n    background-color: #dc3545;\r\n    color: white;\r\n}\r\n\r\n.modalBody {\r\n    flex: 1;\r\n    padding: 20px;\r\n    overflow: hidden;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.loadingContainer {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    height: 100%;\r\n    color: #6c757d;\r\n}\r\n\r\n.spinner {\r\n    width: 40px;\r\n    height: 40px;\r\n    border: 4px solid #f3f3f3;\r\n    border-top: 4px solid #333333;\r\n    border-radius: 50%;\r\n    animation: spin 1s linear infinite;\r\n    margin-bottom: 16px;\r\n}\r\n\r\n@keyframes spin {\r\n    0% { transform: rotate(0deg); }\r\n    100% { transform: rotate(360deg); }\r\n}\r\n\r\n.errorContainer {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    height: 100%;\r\n}\r\n\r\n.errorMessage {\r\n    color: #dc3545;\r\n    font-size: 1.1rem;\r\n    margin-bottom: 16px;\r\n    text-align: center;\r\n}\r\n\r\n.retryButton {\r\n    background-color: #333333;\r\n    color: white;\r\n    border: none;\r\n    padding: 10px 20px;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    font-size: 1rem;\r\n    transition: background-color 0.2s ease;\r\n}\r\n\r\n.retryButton:hover {\r\n    background-color: #000000;\r\n}\r\n\r\n.diagramContainer {\r\n    flex: 1;\r\n    overflow: auto;\r\n    background-color: #fafafa;\r\n    border: 1px solid #e1e5e9;\r\n    border-radius: 4px;\r\n    padding: 20px;\r\n    position: relative;\r\n    cursor: grab;\r\n    user-select: none;\r\n}\r\n\r\n.diagramWrapper {\r\n    width: max-content;\r\n    height: max-content;\r\n    min-width: 100%;\r\n    min-height: 400px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: flex-start;\r\n}\r\n\r\n.diagramWrapper svg {\r\n    display: block;\r\n}\r\n\r\n.emptyContainer {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    height: 100%;\r\n    color: #6c757d;\r\n    font-size: 1.1rem;\r\n}\r\n\r\n/* 스크롤바 스타일링 */\r\n.diagramContainer::-webkit-scrollbar {\r\n    width: 8px;\r\n    height: 8px;\r\n}\r\n\r\n.diagramContainer::-webkit-scrollbar-track {\r\n    background: #f1f1f1;\r\n    border-radius: 4px;\r\n}\r\n\r\n.diagramContainer::-webkit-scrollbar-thumb {\r\n    background: #c1c1c1;\r\n    border-radius: 4px;\r\n}\r\n\r\n.diagramContainer::-webkit-scrollbar-thumb:hover {\r\n    background: #a8a8a8;\r\n}\r\n\r\n/* 새로운 레이아웃 스타일 */\r\n.bodyLayout {\r\n    display: flex;\r\n    height: 100%;\r\n    gap: 1px;\r\n}\r\n\r\n.tableListPanel {\r\n    width: 280px;\r\n    background-color: #f8f9fa;\r\n    border-right: 1px solid #e1e5e9;\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow: hidden;\r\n}\r\n\r\n.tableListHeader {\r\n    padding: 12px;\r\n    border-bottom: 1px solid #e1e5e9;\r\n    background-color: white;\r\n}\r\n\r\n.tableListHeader h3 {\r\n    margin: 0 0 8px 0;\r\n    font-size: 1rem;\r\n    font-weight: 600;\r\n    color: #2c3e50;\r\n}\r\n\r\n.schemaSelectContainer {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    margin-bottom: 8px;\r\n}\r\n\r\n.schemaLabel {\r\n    font-size: 0.9rem;\r\n    color: #495057;\r\n    font-weight: 500;\r\n    white-space: nowrap;\r\n}\r\n\r\n.schemaSelect {\r\n    width: 120px;\r\n    padding: 4px 8px;\r\n    border: 1px solid #dee2e6;\r\n    border-radius: 4px;\r\n    font-size: 0.85rem;\r\n    background-color: white;\r\n    cursor: pointer;\r\n}\r\n\r\n.schemaSelect:focus {\r\n    outline: none;\r\n    border-color: #333333;\r\n    box-shadow: 0 0 0 2px rgba(51, 51, 51, 0.25);\r\n}\r\n\r\n.searchInput {\r\n    width: 200px;\r\n    padding: 4px 8px;\r\n    border: 1px solid #dee2e6;\r\n    border-radius: 4px;\r\n    font-size: 0.85rem;\r\n    margin-bottom: 8px;\r\n}\r\n\r\n.searchInput:focus {\r\n    outline: none;\r\n    border-color: #333333;\r\n    box-shadow: 0 0 0 2px rgba(51, 51, 51, 0.25);\r\n}\r\n\r\n.selectAllContainer {\r\n    margin-top: 8px;\r\n}\r\n\r\n.checkboxLabel {\r\n    display: flex;\r\n    align-items: center;\r\n    font-size: 0.9rem;\r\n    color: #495057;\r\n    cursor: pointer;\r\n    user-select: none;\r\n}\r\n\r\n.checkbox {\r\n    margin-right: 8px;\r\n    cursor: pointer;\r\n}\r\n\r\n.tableList {\r\n    flex: 1;\r\n    overflow-y: auto;\r\n    padding: 8px;\r\n}\r\n\r\n.tableItem {\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 8px 12px;\r\n    margin: 2px 0;\r\n    background-color: white;\r\n    border: 1px solid #e9ecef;\r\n    border-radius: 4px;\r\n    transition: all 0.2s ease;\r\n    font-size: 0.85rem;\r\n    gap: 8px;\r\n}\r\n\r\n.tableItem:hover {\r\n    border-color: #333333;\r\n}\r\n\r\n.tableItem input[type=\"checkbox\"]:checked ~ .tableName {\r\n    font-weight: 600;\r\n    color: #333333;\r\n}\r\n\r\n/* 드래그 앤 드롭 스타일 */\r\n.tableItem[draggable=\"true\"] {\r\n    cursor: move;\r\n    transition: all 0.2s ease;\r\n}\r\n\r\n.tableItem[draggable=\"true\"]:hover {\r\n    background-color: #f5f5f5;\r\n    box-shadow: 0 2px 8px rgba(51, 51, 51, 0.2);\r\n}\r\n\r\n.tableItem.dragging {\r\n    opacity: 0.6;\r\n    background-color: #e8e8e8 !important;\r\n    border: 2px dashed #333333 !important;\r\n    z-index: 1000;\r\n}\r\n\r\n.tableItem.dragOver {\r\n    border-top: 3px solid #333333 !important;\r\n    background-color: #f5f5f5 !important;\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 4px 12px rgba(51, 51, 51, 0.3);\r\n}\r\n\r\n.tableName {\r\n    word-break: break-all;\r\n    line-height: 1.3;\r\n    cursor: pointer;\r\n    flex: 1;\r\n    padding: 2px 4px;\r\n    border-radius: 3px;\r\n    transition: background-color 0.2s ease;\r\n}\r\n\r\n.tableName:hover {\r\n    background-color: #e8e8e8;\r\n    color: #333333;\r\n}\r\n\r\n.diagramArea {\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow: hidden;\r\n}\r\n\r\n/* 테이블 목록 스크롤바 스타일링 */\r\n.tableList::-webkit-scrollbar {\r\n    width: 6px;\r\n}\r\n\r\n.tableList::-webkit-scrollbar-track {\r\n    background: #f1f1f1;\r\n    border-radius: 3px;\r\n}\r\n\r\n.tableList::-webkit-scrollbar-thumb {\r\n    background: #c1c1c1;\r\n    border-radius: 3px;\r\n}\r\n\r\n.tableList::-webkit-scrollbar-thumb:hover {\r\n    background: #a8a8a8;\r\n}\r\n\r\n/* 소스 코드 컨테이너 스타일 */\r\n.sourceCodeContainer {\r\n    flex: 1;\r\n    overflow: hidden;\r\n    background-color: #fafafa;\r\n    border: 1px solid #e1e5e9;\r\n    border-radius: 4px;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.sourceCodeHeader {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 16px 20px;\r\n    border-bottom: 1px solid #e1e5e9;\r\n    background-color: #f8f9fa;\r\n}\r\n\r\n.sourceCodeHeader h3 {\r\n    margin: 0;\r\n    font-size: 1.1rem;\r\n    font-weight: 600;\r\n    color: #2c3e50;\r\n}\r\n\r\n.copyButton {\r\n    background-color: #333333;\r\n    color: white;\r\n    border: none;\r\n    padding: 8px 16px;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    font-size: 0.9rem;\r\n    transition: background-color 0.2s ease;\r\n}\r\n\r\n.copyButton:hover {\r\n    background-color: #000000;\r\n}\r\n\r\n.sourceCode {\r\n    flex: 1;\r\n    overflow: auto;\r\n    margin: 0;\r\n    padding: 20px;\r\n    background-color: #f8f9fa;\r\n    font-family: 'Consolas', 'Monaco', 'Courier New', monospace;\r\n    font-size: 0.9rem;\r\n    line-height: 1.5;\r\n    white-space: pre-wrap;\r\n    word-wrap: break-word;\r\n}\r\n\r\n.sourceCode code {\r\n    background: none;\r\n    padding: 0;\r\n    border: none;\r\n    color: #2c3e50;\r\n}\r\n\r\n/* 소스 코드 스크롤바 스타일링 */\r\n.sourceCode::-webkit-scrollbar {\r\n    width: 8px;\r\n    height: 8px;\r\n}\r\n\r\n.sourceCode::-webkit-scrollbar-track {\r\n    background: #f1f1f1;\r\n    border-radius: 4px;\r\n}\r\n\r\n.sourceCode::-webkit-scrollbar-thumb {\r\n    background: #c1c1c1;\r\n    border-radius: 4px;\r\n}\r\n\r\n.sourceCode::-webkit-scrollbar-thumb:hover {\r\n    background: #a8a8a8;\r\n}\r\n\r\n/* 비활성화된 버튼 스타일 */\r\n.controlButton:disabled {\r\n    opacity: 0.5;\r\n    cursor: not-allowed;\r\n}\r\n\r\n/* 반응형 디자인 */\r\n@media (max-width: 768px) {\r\n    .modalOverlay {\r\n        padding: 10px;\r\n    }\r\n\r\n    .modalContent {\r\n        width: 100%;\r\n        height: calc(95vh / var(--app-zoom, 1));\r\n        max-width: 100%;\r\n        max-height: calc(95vh / var(--app-zoom, 1));\r\n    }\r\n\r\n    .modalHeader {\r\n        padding: 16px;\r\n    }\r\n\r\n    .modalTitle {\r\n        font-size: 1.3rem;\r\n    }\r\n\r\n    .modalBody {\r\n        padding: 16px;\r\n    }\r\n\r\n    .bodyLayout {\r\n        flex-direction: column;\r\n    }\r\n\r\n    .tableListPanel {\r\n        width: 100%;\r\n        height: 200px;\r\n        border-right: none;\r\n        border-bottom: 1px solid #e1e5e9;\r\n    }\r\n\r\n    .diagramArea {\r\n        flex: 1;\r\n        min-height: 300px;\r\n    }\r\n}\r\n\r\n/* Mermaid ERD 스타일 커스터마이징 */\r\n.diagramWrapper :global(.er) {\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n\r\n.diagramWrapper :global(.er .entityBox) {\r\n    fill: #f8f9fa;\r\n    stroke: #6c757d;\r\n    stroke-width: 1px;\r\n}\r\n\r\n.diagramWrapper :global(.er .entityLabel) {\r\n    fill: #2c3e50;\r\n    font-weight: 900;\r\n    font-size: 18px;\r\n}\r\n\r\n.diagramWrapper :global(.er .attributeBoxEven) {\r\n    fill: #ffffff;\r\n    stroke: #dee2e6;\r\n}\r\n\r\n.diagramWrapper :global(.er .attributeBoxOdd) {\r\n    fill: #f8f9fa;\r\n    stroke: #dee2e6;\r\n}\r\n\r\n/* ======== 다크모드 ======== */\r\n:global([data-theme=\"dark\"]) .modalContent { background: var(--color-bg); }\r\n:global([data-theme=\"dark\"]) .modalHeader { background: var(--color-bg-secondary); border-color: var(--color-border); }\r\n:global([data-theme=\"dark\"]) .modalTitle { color: var(--color-text); }\r\n:global([data-theme=\"dark\"]) .zoomSelect { background: var(--color-bg); color: var(--color-text); border-color: var(--color-border); }\r\n:global([data-theme=\"dark\"]) .controlButton { background: transparent; border-color: var(--color-border); color: var(--color-text-muted); }\r\n:global([data-theme=\"dark\"]) .controlButton:hover { background: var(--color-hover); color: var(--color-text); }\r\n\r\n:global([data-theme=\"dark\"]) .diagramContainer { background: var(--color-bg); border-color: var(--color-border); }\r\n:global([data-theme=\"dark\"]) .emptyContainer, :global([data-theme=\"dark\"]) .loadingContainer, :global([data-theme=\"dark\"]) .checkboxLabel, :global([data-theme=\"dark\"]) .schemaLabel { color: var(--color-text); }\r\n\r\n:global([data-theme=\"dark\"]) .tableListPanel { background: var(--color-bg); border-color: var(--color-border); }\r\n:global([data-theme=\"dark\"]) .tableListHeader { background: var(--color-bg-secondary); border-color: var(--color-border); }\r\n:global([data-theme=\"dark\"]) .tableListHeader h3 { color: var(--color-text); }\r\n\r\n:global([data-theme=\"dark\"]) .schemaSelect, :global([data-theme=\"dark\"]) .searchInput { background: var(--color-bg); color: var(--color-text); border-color: var(--color-border); }\r\n:global([data-theme=\"dark\"]) .schemaSelect:focus, :global([data-theme=\"dark\"]) .searchInput:focus { border-color: var(--color-primary); box-shadow: 0 0 0 2px rgba(33,150,243,0.3); }\r\n\r\n:global([data-theme=\"dark\"]) .tableItem { background: var(--color-bg-secondary); border-color: var(--color-border); color: var(--color-text); }\r\n:global([data-theme=\"dark\"]) .tableItem:hover { border-color: var(--color-text); background: var(--color-hover); }\r\n:global([data-theme=\"dark\"]) .tableItem input[type=\"checkbox\"]:checked ~ .tableName { color: var(--color-text); }\r\n:global([data-theme=\"dark\"]) .tableName:hover { background: var(--color-hover); color: var(--color-text); }\r\n\r\n:global([data-theme=\"dark\"]) .sourceCodeContainer { border-color: var(--color-border); }\r\n:global([data-theme=\"dark\"]) .sourceCodeHeader { background: var(--color-bg-secondary); border-color: var(--color-border); }\r\n:global([data-theme=\"dark\"]) .sourceCodeHeader h3 { color: var(--color-text); }\r\n:global([data-theme=\"dark\"]) .sourceCode { background: var(--color-bg); color: var(--color-text); }\r\n\r\n/* 다크모드 ERD - CSS 모듈에서는 ERD가 global 렌더링되므로 특수 처리 */\r\n:global([data-theme=\"dark\"]) .diagramWrapper :global(.er .entityBox) { fill: var(--color-bg-secondary); stroke: var(--color-border); }\r\n:global([data-theme=\"dark\"]) .diagramWrapper :global(.er .entityLabel) { fill: var(--color-text); }\r\n:global([data-theme=\"dark\"]) .diagramWrapper :global(.er .attributeBoxEven) { fill: var(--color-bg); stroke: var(--color-border); }\r\n:global([data-theme=\"dark\"]) .diagramWrapper :global(.er .attributeBoxOdd) { fill: var(--color-bg-tertiary); stroke: var(--color-border); }\r\n:global([data-theme=\"dark\"]) .diagramWrapper :global(.er text) { fill: var(--color-text) !important; }\r\n:global([data-theme=\"dark\"]) .diagramWrapper :global(.er rect) { stroke: var(--color-border); }\r\n:global([data-theme=\"dark\"]) .diagramWrapper :global(.er path) { stroke: #888 !important; } /* 관계선 대비 */\r\n/*\r\n * 주변만 보기 — 큰 스키마에서 ERD 를 되살리는 축은 **표를 줄이는 것**이다.\r\n * (컬럼을 숨기면 표 300개는 여전히 300개고 정보만 빠진다)\r\n */\r\n.hopContainer { margin-top: 10px; }\r\n.hopRow { display: flex; gap: 4px; margin-top: 4px; }\r\n.hopSelect { flex: 1; min-width: 0; }\r\n.hopSelect, .hopDepth, .hopApply {\r\n  padding: 4px 6px; font-size: 12px; border-radius: 4px;\r\n  border: 1px solid var(--color-border, #ccc);\r\n  background: var(--color-bg, #fff); color: var(--color-text, #222);\r\n}\r\n.hopApply { cursor: pointer; white-space: nowrap; }\r\n.hopApply:disabled { opacity: 0.5; cursor: default; }\r\n.hopHint { margin-top: 4px; font-size: 10.5px; line-height: 1.5; opacity: 0.6; }\r\n\r\n[data-theme=\"dark\"] .hopSelect,\r\n[data-theme=\"dark\"] .hopDepth,\r\n[data-theme=\"dark\"] .hopApply {\r\n  background: var(--color-bg-tertiary, #2a2a2a);\r\n  border-color: var(--color-border, #444);\r\n  color: var(--color-text, #eee);\r\n}\r\n\r\n/*\r\n * 관계선 — mermaid 기본 선이 **너무 옅어 안 보인다**(특히 다크에서, 그리고 추정 관계의\r\n * 점선은 더 흐리다). 선이 안 보이면 ERD 는 상자 목록일 뿐이다.\r\n *\r\n * 색은 상자 테두리보다 진하게, 굵기는 1.6px. 점선은 간격을 넓혀 실선과 **한눈에** 갈린다 —\r\n * 선언된 FK 와 추정을 구분하는 것이 이 화면의 요점이다.\r\n */\r\n.diagramContainer :global(svg .relationshipLine),\r\n.diagramContainer :global(svg path.relationshipLine),\r\n.diagramContainer :global(svg .er.relationshipLine) {\r\n  stroke: #4a6f96 !important;\r\n  stroke-width: 1.6px !important;\r\n}\r\n/* mermaid 는 점선을 **클래스**(`edge-pattern-dashed`)로 건다 — 속성 선택자로는 안 잡힌다 */\r\n.diagramContainer :global(svg .relationshipLine.edge-pattern-dashed) {\r\n  stroke: #9a6b17 !important;      /* 추정 — 노란 계열로 확정과 구분 */\r\n  stroke-dasharray: 7 5 !important;\r\n}\r\n/* 관계 라벨도 옅어서 어느 컬럼으로 이어지는지 안 읽힌다 */\r\n/* 라벨 뒤 상자 — 기본이 반투명이라 선과 겹치면 글자가 안 읽힌다 */\r\n.diagramContainer :global(svg .relationshipLabelBox) { opacity: 0.92; }\r\n\r\n[data-theme=\"dark\"] .diagramContainer :global(svg .relationshipLine),\r\n[data-theme=\"dark\"] .diagramContainer :global(svg path.relationshipLine),\r\n[data-theme=\"dark\"] .diagramContainer :global(svg .er.relationshipLine) {\r\n  stroke: #8ab4e8 !important;\r\n}\r\n[data-theme=\"dark\"] .diagramContainer :global(svg .relationshipLine.edge-pattern-dashed) {\r\n  stroke: #e0be82 !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `ERDModal_modalOverlay__Zprsh`,
	"fullscreen": `ERDModal_fullscreen__yyw0m`,
	"modalContent": `ERDModal_modalContent__IpqGT`,
	"fullscreenContent": `ERDModal_fullscreenContent__40yoF`,
	"modalHeader": `ERDModal_modalHeader__iajJQ`,
	"modalTitle": `ERDModal_modalTitle__7AfPi`,
	"zoomControls": `ERDModal_zoomControls__xxlhs`,
	"zoomSelect": `ERDModal_zoomSelect__mRQVl`,
	"modalControls": `ERDModal_modalControls__yku4P`,
	"controlButton": `ERDModal_controlButton__iX91c`,
	"closeButton": `ERDModal_closeButton__6WnVw`,
	"modalBody": `ERDModal_modalBody__A7IIo`,
	"loadingContainer": `ERDModal_loadingContainer__cucSt`,
	"spinner": `ERDModal_spinner__rvl2n`,
	"spin": `ERDModal_spin__6giqz`,
	"errorContainer": `ERDModal_errorContainer__wdV0A`,
	"errorMessage": `ERDModal_errorMessage__rVlXz`,
	"retryButton": `ERDModal_retryButton__58lRF`,
	"diagramContainer": `ERDModal_diagramContainer__qy3p8`,
	"diagramWrapper": `ERDModal_diagramWrapper__b9os8`,
	"emptyContainer": `ERDModal_emptyContainer__X4sAy`,
	"bodyLayout": `ERDModal_bodyLayout__uJ-Nl`,
	"tableListPanel": `ERDModal_tableListPanel__PHBru`,
	"tableListHeader": `ERDModal_tableListHeader__CdiJs`,
	"schemaSelectContainer": `ERDModal_schemaSelectContainer__1WEhp`,
	"schemaLabel": `ERDModal_schemaLabel__kR4Eb`,
	"schemaSelect": `ERDModal_schemaSelect__OmZHy`,
	"searchInput": `ERDModal_searchInput__D9bpY`,
	"selectAllContainer": `ERDModal_selectAllContainer__1tJzc`,
	"checkboxLabel": `ERDModal_checkboxLabel__9mQfH`,
	"checkbox": `ERDModal_checkbox__ELBvp`,
	"tableList": `ERDModal_tableList__dE63b`,
	"tableItem": `ERDModal_tableItem__OFuHT`,
	"tableName": `ERDModal_tableName__Apx71`,
	"dragging": `ERDModal_dragging__NHtzh`,
	"dragOver": `ERDModal_dragOver__lBV-B`,
	"diagramArea": `ERDModal_diagramArea__ea7A+`,
	"sourceCodeContainer": `ERDModal_sourceCodeContainer__ZW6Kc`,
	"sourceCodeHeader": `ERDModal_sourceCodeHeader__8eQi5`,
	"copyButton": `ERDModal_copyButton__Gq8pb`,
	"sourceCode": `ERDModal_sourceCode__SHbSC`,
	"hopContainer": `ERDModal_hopContainer__gKCry`,
	"hopRow": `ERDModal_hopRow__mA+zZ`,
	"hopSelect": `ERDModal_hopSelect__Dxnd1`,
	"hopDepth": `ERDModal_hopDepth__Ec-Hn`,
	"hopApply": `ERDModal_hopApply__pnPBq`,
	"hopHint": `ERDModal_hopHint__zVXcB`
};
export default ___CSS_LOADER_EXPORT___;
